import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import { clearSession } from "../../utils/session";

const hasSession = () => Boolean(localStorage.getItem("token") && localStorage.getItem("user"));

// Mounted once for all protected pages (Routing.js no longer keys it by path,
// which remounted it and flashed the loading screen on every page change).
// It still re-checks the session on every navigation, and when another tab
// signs out, without remounting anything.
function ProtectComponent(props) {
  // Read synchronously: a signed-in admin goes straight to the page.
  const [isLogedIn, setIsLogedIn] = useState(hasSession);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const check = () => {
      if (hasSession()) {
        setIsLogedIn(true);
        return;
      }
      setIsLogedIn(false);
      clearSession();
      navigate("/");
      toast.error("Access denied. You need to log in");
    };
    check();

    const onStorage = (event) => {
      if (event.key === null || event.key === "token" || event.key === "user") check();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return isLogedIn ? props.children : <LoadingSpinner />;
}

export default ProtectComponent;
